import React from 'react';
import '../../css/InlineBanner.css';

const DEFAULT_ICONS = {
    info: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
    ),
    success: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    warning: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
    ),
    danger: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
};

/**
 * InlineBanner — themed status message (replaces ad-hoc colored <div>s and the
 * native-color inline error/success text scattered across forms).
 *
 * Props:
 *   variant   — 'info' | 'success' | 'warning' | 'danger' (default 'info')
 *   title     — optional bold heading
 *   children  — body text
 *   icon      — override the default variant icon (pass null to hide)
 *   onDismiss — show a dismiss button when provided
 */
const InlineBanner = ({ variant = 'info', title, children, icon, onDismiss, className = '', ...rest }) => {
    const resolvedIcon = icon === undefined ? DEFAULT_ICONS[variant] : icon;
    return (
        <div
            className={`qd-banner qd-banner--${variant} ${className}`.trim()}
            role={variant === 'danger' || variant === 'warning' ? 'alert' : 'status'}
            {...rest}
        >
            {resolvedIcon && <span className="qd-banner-icon" aria-hidden="true">{resolvedIcon}</span>}
            <div className="qd-banner-content">
                {title && <p className="qd-banner-title">{title}</p>}
                {children && <p className="qd-banner-body">{children}</p>}
            </div>
            {onDismiss && (
                <button type="button" className="qd-banner-dismiss" onClick={onDismiss} aria-label="Dismiss">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default InlineBanner;
